/* Flow theme — vanilla JS */
(function () {
  'use strict';

  // ---------- Drawer helpers ----------
  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-drawer-open');
      var drawer = document.getElementById(id);
      openDrawer(drawer);
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('.drawer');
      closeDrawer(drawer);
    });
  });
  document.querySelectorAll('.drawer').forEach(function (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer(drawer);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(closeDrawer);
    }
  });

  // ---------- Sticky header on scroll ----------
  var header = document.querySelector('.site-header');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      lastY = y;
    }, { passive: true });
  }

  // ---------- Marquee duplication for seamless loop ----------
  document.querySelectorAll('.marquee-track').forEach(function (track) {
    if (track.dataset.duplicated === 'true') return;
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    // wrap original + clone
    var parent = track.parentNode;
    var wrap = document.createElement('div');
    wrap.className = 'marquee-track-wrap';
    wrap.style.display = 'flex';
    parent.replaceChild(wrap, track);
    track.dataset.duplicated = 'true';
    // We just want duplicated content within a single sliding track.
    // Simpler: append clones inline.
    Array.prototype.slice.call(track.children).forEach(function (child) {
      var c = child.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    });
    wrap.appendChild(track);
  });

  // ---------- Sticky add-to-cart on PDP ----------
  var stickyAtc = document.querySelector('.sticky-atc');
  var pdpAtcButton = document.querySelector('.pdp-atc');
  if (stickyAtc && pdpAtcButton) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    observer.observe(pdpAtcButton);
  }

  // ---------- Add to cart fetch + toast ----------
  function showToast(msg) {
    var region = document.getElementById('ToastRegion');
    if (!region) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    region.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }

  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('Added to cart');
          var drawer = document.getElementById('CartDrawer');
          if (drawer) {
            refreshCartDrawer().then(function () { openDrawer(drawer); });
          }
        })
        .catch(function (err) {
          showToast('Could not add. Try again.');
          console.error(err);
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText || 'Add to cart';
          }
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count || count === '0' || count === 0;
    });
  }

  function refreshCartDrawer() {
    var drawerBody = document.querySelector('#CartDrawer [data-cart-drawer-body]');
    if (!drawerBody) return Promise.resolve();
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function () {
        // Fallback: refresh /cart.js and re-render minimally
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        renderCartDrawer(cart);
      });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('#CartDrawer [data-cart-drawer-body]');
    var footer = document.querySelector('#CartDrawer [data-cart-drawer-footer]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p></div>';
      if (footer) footer.innerHTML = '';
      return;
    }
    var html = cart.items.map(function (item) {
      return '<div class="cart-drawer-item">' +
        '<div class="cart-drawer-item-media">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>' +
        '<div class="cart-drawer-item-info">' +
          '<p class="cart-drawer-item-title">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer-item-meta">' + item.variant_title + '</p>' : '') +
          '<p class="cart-drawer-item-meta">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.line_price) + '</p>' +
        '</div>' +
      '</div>';
    }).join('');
    body.innerHTML = html;
    if (footer) {
      footer.innerHTML =
        '<div class="cart-drawer-totals"><span>Subtotal</span><span>' + formatMoney(cart.items_subtotal_price) + '</span></div>' +
        '<a href="/cart" class="btn btn-outline btn-block" style="margin-bottom:8px">View cart</a>' +
        '<a href="/checkout" class="btn btn-solid btn-block">Checkout</a>';
    }
  }

  // ---------- PDP variant selection ----------
  document.querySelectorAll('.variant-options').forEach(function (group) {
    var inputs = group.querySelectorAll('input[type="radio"]');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        group.querySelectorAll('.variant-option').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.contains(input) && input.checked);
        });
      });
    });
  });

  // ---------- Quantity steppers ----------
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    if (!input) return;
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---------- Newsletter form -> show inline success ----------
  document.querySelectorAll('form[data-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function () {
      // Native submit goes through to Shopify, but show a soft state immediately
      form.classList.add('is-submitting');
    });
  });

})();
